import { BanzaIconsPlugin } from "@products/base-portal-lib/plugins";

import kredo from "@/icons/kredo";

export default defineNuxtPlugin({
	name: "icons",
	order: 1060,
	setup: () => {
		BanzaIconsPlugin.use([kredo]);
	},
});
